/**
 * @generated SignedSource<<dc2fd21445737c6de095b4d8ffe41d6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductTypeTagFragment$data = {
  readonly typeTag: {
    readonly color: string;
    readonly label: string;
  } | null;
  readonly " $fragmentType": "ProductTypeTagFragment";
};
export type ProductTypeTagFragment$key = {
  readonly " $data"?: ProductTypeTagFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductTypeTagFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductTypeTagFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "typeTag",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "11762384b84181bc31b370e2867bf0b9";

export default node;
